'use client';

import React from 'react';
import Link from 'next/link';
import { postAPI } from '@/lib/api';
import type { Post } from '@/types/api';

interface LatestArticlesProps {
  limit?: number;
}

/**
 * 最新文章组件
 * 显示侧边栏中的最新文章列表
 */
export default function LatestArticles({ limit = 4 }: LatestArticlesProps) {
  const [articles, setArticles] = React.useState<Post[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const fetchLatestArticles = async () => {
      try {
        setLoading(true);
        const response = await postAPI.getList({
          limit: limit,
          status: 'published',
        });

        if (response && response.data) {
          setArticles(response.data);
        }
      } catch (error) {
        console.error('Failed to fetch latest articles:', error);
        // 使用默认数据作为后备
        setArticles([
          {
            id: '1',
            title: 'SANY Equipment in Infrastructure Projects',
            slug: 'belt-and-road',
            publishedAt: '2024-03-15',
          } as Post,
          {
            id: '2',
            title: 'Advancements in Smart Manufacturing',
            slug: 'smart-manufacturing',
            publishedAt: '2024-03-10',
          } as Post,
          {
            id: '3',
            title: '2025 After-Sales Service Upgrade',
            slug: 'service-upgrade',
            publishedAt: '2024-03-05',
          } as Post,
          {
            id: '4',
            title: 'Green Development in Construction',
            slug: 'green-development',
            publishedAt: '2024-02-28',
          } as Post,
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchLatestArticles();
  }, [limit]);

  if (loading) {
    return (
      <ul className="sidebar-menu">
        {[...Array(limit)].map((_, i) => (
          <li key={i}>
            <a href="#" className="sidebar-link" style={{ opacity: 0.5 }}>
              <span className="article-title">Loading...</span>
              <span className="article-date">...</span>
            </a>
          </li>
        ))}
      </ul>
    );
  }

  const formatDate = (dateString?: string) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];
    } catch {
      return dateString;
    }
  };

  return (
    <ul className="sidebar-menu">
      {articles.map((article) => (
        <li key={article.id}>
          <Link href={`/news/${article.slug}`} className="sidebar-link">
            <span className="article-title">{article.title}</span>
            {article.publishedAt && (
              <span className="article-date">{formatDate(article.publishedAt)}</span>
            )}
          </Link>
        </li>
      ))}
    </ul>
  );
}

